import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body p-0" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div style=\"padding:24px 27px 0px 27px;\"><div class=\"me-2 flex-grow-1\"><div class=\"fs-3 mb-2\"><span style=\"color:grey;\">฿ </span><span class=\"fw-boldest\">1,224,567 </span><button style=\"padding:5px;\" class=\"btn btn-sm btn-light-success fw-boldest\"><i class=\"bi bi-arrow-down\"></i>3.2% </button></div><div class=\"fw-bold fs-6 text-gray-600\">มูลค่าคลังสินค้าปัจจุบัน</div></div></div>", 1)
const _hoisted_3 = { class: "mt-3 pb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "row pb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center text-gray-600 fw-boldest" }, "Min")
], -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_7 = { class: "col-8" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"margin-top":"-15px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-end text-gray-600 fw-boldest" }, "Low"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-4" }),
  /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-gray-600 fw-boldest" }, "Max")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_apexchart, {
              type: "radialBar",
              height: "170",
              options: _ctx.chartOptions,
              series: _ctx.series
            }, null, 8, ["options", "series"])
          ]),
          _hoisted_8
        ]),
        _hoisted_9
      ])
    ])
  ], 2))
}